var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"readonly":_vm.readonly,"label":"Subvariant","hint":"What subvariant is this? Irish Single Malt Island Whisky?","persistent-hint":"","items":_vm.subvariants,"value":_vm.subvariant},on:{"change":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }